import * as React from 'react';
import classNames from 'classnames';
import {FocusRing} from 'react-focus-rings';
import {MenuIcon} from '@discordapp/design/components/Icon/generated/MenuIcon.web';

import Clickable from './Clickable';

import styles from './HamburgerButton.module.css';

interface Props {
  className?: string;
  onClick?: () => void;
  accessibilityLabel?: string;
}

const HamburgerButton = ({className, onClick}: Props) => {
  return (
    <FocusRing>
      <Clickable onClick={onClick} className={classNames(className, styles.button)}>
        <MenuIcon className={styles.icon} color="currentColor" />
      </Clickable>
    </FocusRing>
  );
};

export default HamburgerButton;
